/**
 * USER SAVED TRACKS PAGE
 */
export const userSavedTitlesActionTypes = {
  FETCH_USER_SAVED_TITLES_START: "FETCH_USER_SAVED_TITLES_START",
  FETCH_USER_SAVED_TITLES_START_SUCCESS:
    "FETCH_USER_SAVED_TITLES_START_SUCCESS",
  FETCH_USER_SAVED_TITLES_START_ERROR: "FETCH_USER_SAVED_TITLES_START_ERROR",
  SET_USER_SAVED_TITLES: "SET_USER_SAVED_TITLES",
};
